import React from 'react';
import { CTAButton } from '../shared/CTAButton';
import { Section, SectionHeading, Reveal } from '../shared/Section';
const pains = [{
  emoji: '😩',
  text: 'Tenés dolor lumbar que va y viene hace meses y nunca encontrás alivio real.'
}, {
  emoji: '💸',
  text: 'Gastaste en masajes, fisioterapia o pastillas que solo alivian unas horas.'
}, {
  emoji: '⚡',
  text: 'El cuello y los hombros se te cargan después de horas frente a la pantalla.'
}, {
  emoji: '🦵',
  text: 'Sentís crujidos o molestias en las rodillas al subir escaleras o levantarte.'
}, {
  emoji: '⏰',
  text: 'Querés moverte y estirarte pero no sabés por dónde empezar sin hacerte daño.'
}, {
  emoji: '🧊',
  text: 'Cada mañana el cuerpo está más rígido — sentís que no te pertenece.'
}];
export function PainPoints() {
  return <Section id="identificacion" bg="bg-white" data-id="element-169" data-mp="w6lw0eatrngg">
      <Reveal data-id="element-170" data-mp="w7f8zx0dn971">
        <SectionHeading eyebrow="¿Te identificás?" title="¿Cuántas veces intentaste convivir con el dolor y volviste al mismo punto?" subtitle="Millones de personas se despiertan todos los días con rigidez o dolor. Lo ignoran, toman un analgésico y siguen. Pero el dolor no desaparece solo. Empeora." data-id="element-171" data-mp="w8yovmi4fi8a" />
      </Reveal>

      <div className="mt-12 grid gap-4 sm:grid-cols-2" data-id="element-172" data-mp="1x4y8sam7xiuj">
        {pains.map((p, i) => <Reveal key={p.text} index={i} data-id="element-173" data-mp="21wzltyr7ndlm" data-mpi={i}>
            <div className="flex h-full items-start gap-4 rounded-2xl border border-sand-200 bg-sand-50 p-5 transition-colors duration-200 hover:border-forest-100" data-id="element-174" data-mp="21ysqj8i9jnqz">
              <span className="text-2xl leading-none" aria-hidden data-id="element-175" data-mp="2awcqme4e3e00">
                {p.emoji}
              </span>
              <p className="text-[0.975rem] leading-relaxed text-forest-700/85" data-id="element-176" data-mp="2fx0hmzsmbuu8">{p.text}</p>
            </div>
          </Reveal>)}
      </div>

      <Reveal index={2} data-id="element-177" data-mp="lipviz3eres5">
        <div className="mt-12 text-center" data-id="element-178" data-mp="ljhr49x09cif">
          <p className="mb-6 font-display text-xl text-forest-800 sm:text-2xl" data-id="element-179" data-mp="lkkj6l62dkzx">
            Si dijiste sí a alguno de estos puntos, este programa es exactamente para vos.
          </p>
          <CTAButton size="lg" data-id="element-180" data-mp="ih4x0fn7ad3h">SÍ, QUIERO MOVERME SIN DOLOR</CTAButton>
        </div>
      </Reveal>
    </Section>;
}